<template>
    <div class="bg" :style="{width: fullWidth+'px', height:fullHeight+'px'}">
        <el-card class="box-card" :style="{marginTop: marginTop+'%', marginLeft:marginLeft+'%'}" v-if="isShow">
            <el-form :model="user" status-icon :rules="rules" ref="user" label-width="100px" class="demo-ruleForm">
                <el-form-item label-width="0px" prop="userName">
                    <el-input type="text" placeholder="QQ号" v-model="user.userName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label-width="0px" prop="password">
                    <el-input type="password" placeholder="密码" v-model="user.password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label-width="0px">
                    <el-button type="primary"  @keyup.enter.native="enterLogin" @click="login('user')">登录</el-button>
                </el-form-item>
            </el-form>
            <el-link style="float:left" type="primary" @click="toRegister">新用户注册</el-link>
            <el-link style="float:left" class="pass" type="primary" @click="toFindPass">找回密码</el-link>
            <el-link style="float:left; color:red;" class="flowText" href="http://www.bt-lab.cn/cn/info_208.aspx?itemid=226" target="_blank">流程说明</el-link>
            <el-link style="float:right; color:red;" class="addQq" type="primary" @click="addQq">加入QQ福利群</el-link>
        </el-card>
    </div>
    
</template>

<script>
    import globeCommon from '../assets/js/GlobeCommon.js'

    export default {
        name:'Login',
        data() {
            return {
                user:{
                    userName:"",
                    password:""
                },
                rules: {
                    userName: [
                        { required: true, message: "请输QQ号", trigger: "blur" },
                        { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
                    ],
                    password: [
                        { required: true, message: "请输入密码", trigger: "blur" },
                        { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
                    ],
                    
                },
                fullWidth: document.documentElement.clientWidth - 1,
                fullHeight: document.documentElement.clientHeight -1,
                marginTop: 10,
                marginLeft: 10,
                isShow :false,
            }
        },
        methods: {
            login(formName) {
                // let  gjsParam = JSON.parse(window.localStorage.getItem("gjs"));
                // if(gjsParam !== null) {
                //     console.log(gjsParam);
                //     this.$message.error("当前已经有账号登录！");
                //     return;
                // }

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.post("/login/login",this.user).then(
                            res=>{
                                if(res.data.status === "success"){
                                    //window.localStorage.setItem("user",JSON.stringify(res.data.result));
                                    window.localStorage.setItem("user",JSON.stringify(res.data.result));
                                    this.user = JSON.parse(window.localStorage.getItem("user"));
                                    globeCommon.userId = this.user.userId;
                                    window.localStorage.setItem("userId",this.user.userId);
                                    window.sessionStorage.setItem("isLogin", true);
                                    if(this.user.roleCode === 'SUPER') {
                                        this.$router.push("/home/orderInfo");
                                    } else if(this.user.roleCode === 'ADMIN') {
                                        this.$router.push("/home/orderInfo");
                                    } else if (this.user.roleCode === 'AGENT') {
                                        this.$router.push("/home/groupOrderInfo");
                                    } else if(this.user.roleCode === 'RESPONSIBLE') {
                                        this.$router.push("/home/myOrderInfo");
                                    } else {
                                        this.$router.push("/home/myOrderInfo");
                                    }
                                } else {
                                    this.$message.error(res.data.message);
                                }
                            },
                            error=>{
                                this.$message.error(error.message);
                            }
                        )
                    } else {
                        return false;
                    }
                });

                
            },
            enterLogin(){
                document.onkeydown =(e) => {
                    e = window.event || e;
                    if(this.$route.path=='/login'&&(e.code=='Enter'||e.code=='enter')){
                        //调用登录事件方法
                        this.login('user');
                    }
                }
            },
            toRegister() {
                this.$router.push("/userRegister");
            },
            toFindPass(){
                this.$message({
                    message: '请联系客服进行密码重置！',
                    type: 'success'
                });
            },
            addQq() {
                window.open("https://qm.qq.com/cgi-bin/qm/qr?k=BN4jT3uvuQNYQlknxi1qFnPx9Sxab7-M&jump_from=webapi&authKey=wf7y4GIiNwGhQdbf/Lieycarc0tHAYqFz70Ood2UN+YRVr8jmnFaf7B6icQegtQ+");
            },
            initLoginPosition() {
                this.$axios.post("/login/findSystemParam").then(
                    res=>{
                        if(res.data.status === "success"){
                           this.marginTop = res.data.result.loginMarginTop;
                           this.marginLeft = res.data.result.loginMarginLeft;
                           this.isShow = true;
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            }
        },
        created() {
            this.enterLogin();
            
        },
        beforeMount() {
            this.initLoginPosition();
        }
        
    }


</script>

<style scoped>

    .text {
        font-size: 14px;
    }

    .item {
        padding: 18px 0;
    }

    .box-card {
        width: 420px;
        position: absolute;
        background-color: rgba(255, 255, 255, 0.1);
        box-shadow: 5px 5x 0 0 rgba(0, 0, 0, 0.2);
    }
    .bg {
        width: 100%;
        height: 100%;
        position: absolute;
        background: url("~@/assets/loginImage.jpg");
        background-size: 100% 100%;
    }
    .el-button {
        width:100%;
    }
    .pass {
        margin-left: 20px;
    }
    .flowText {
        margin-left: 60px;
    }
    .addQq {
        margin-bottom: 20px;
    }

</style>
